export default __webpack_public_path__ + "static/media/Linkedin.567dd105.svg";